/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { type ReactNode } from "react";

import { jsx } from "@compiled/react";

import { Box, xcss } from "@atlaskit/primitives";

const formSectionStyles = xcss({
    marginBlockStart: "space.200"
});

type FormSectionProps = {
    children: ReactNode;
};

export const FormSection = ({ children }: FormSectionProps) => {
    return <Box xcss={formSectionStyles}>{children}</Box>;
};
